export function dashboard(api: ReturnType<typeof useAxios>) {
  const getCounts = async () => await api.$get(`/dashboard`);
  return {
    getCounts,
  };
}
